/* eslint-disable */
/* this file is generated by generateIcons script */

import React from 'react'
import BaseIcon from '../../BaseIcon'

export default class IosIcon extends BaseIcon {
  getChildren = () => [
    <path fill="#999999" d="M26.4,4.8c3-3.9,7.1-3.9,7.1-3.9s0.6,3.7-2.3,7.2c-3.1,3.8-6.7,3.2-6.7,3.2S23.8,8.3,26.4,4.8z M24.8,13.8 c1.5,0,4.3-2.1,8-2.1c6.3,0,8.8,4.5,8.8,4.5s-4.9,2.5-4.9,8.5c0,6.8,6.1,9.2,6.1,9.2s-4.2,11.9-10,11.9c-2.6,0-4.7-1.8-7.4-1.8 c-2.8,0-5.6,1.8-7.4,1.8c-5.2,0-11.8-11.3-11.8-20.4c0-8.9,5.6-13.6,10.8-13.6C20.4,11.8,23,13.8,24.8,13.8L24.8,13.8z"/>
  ]
  getViewBox = () => '0 0 48 48'
}
